import classNames from 'classnames';
import { ReactNode } from 'react';

import { setupForDark } from '@theme';

const MediaitemInlineStatus = ({
  children,
  action,
  className = '',
  'data-testid': dataTestId
}: {
  children: ReactNode;
  action?: ReactNode;
  className?: string;
  'data-testid'?: string;
}) => {
  return (
    <div
      data-testid={dataTestId}
      className={classNames(
        'flex items-center justify-between gap-xs p-sm self-stretch',
        'rounded-xs border border-dashed',
        setupForDark('border-border-dark', 'text-primary'),
        className
      )}
    >
      <div className='flex items-center gap-xs min-w-0'>{children}</div>
      {action}
    </div>
  );
};

export default MediaitemInlineStatus;
